import React from 'react';

const ManagerDashboard = () => {
  return (
    <div style={{ padding: '24px' }}>
      <h1>Manager Dashboard</h1>
      <p>Welcome to the Manager Dashboard. Full implementation coming soon...</p>
    </div>
  );
};

export default ManagerDashboard;
